"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

//     NoFlo - Flow-Based Programming for JavaScript
//     (c) 2013-2017 Flowhub UG
//     (c) 2011-2012 Henri Bergius, Nemein
//     NoFlo may be freely distributed under the MIT license

/* eslint-disable
    class-methods-use-this,
    import/no-unresolved,
*/
var noflo = require('../lib/NoFlo'); // The Graph component is used to wrap NoFlo Networks into components inside
// another network.


var Graph = /*#__PURE__*/function (_noflo$Component) {
  _inherits(Graph, _noflo$Component);

  var _super = _createSuper(Graph);

  function Graph(metadata) {
    var _this;

    _classCallCheck(this, Graph);

    _this = _super.call(this);
    _this.metadata = metadata;
    _this.network = null;
    _this.ready = true;
    _this.started = false;
    _this.starting = false;
    _this.baseDir = null;
    _this.loader = null;
    _this.load = 0;
    _this.inPorts = new noflo.InPorts({
      graph: {
        datatype: 'all',
        description: 'NoFlo graph definition to be used with the subgraph component',
        required: true
      }
    });
    _this.outPorts = new noflo.OutPorts();

    _this.inPorts.graph.on('ip', function (packet) {
      if (packet.type !== 'data') {
        return;
      }

      _this.setGraph(packet.data, function (err) {
        // TODO: Port this part to Process API and use output.error method instead
        if (err) {
          _this.error(err);
        }
      });
    });

    return _this;
  }

  _createClass(Graph, [{
    key: "setGraph",
    value: function setGraph(graph, callback) {
      var _this2 = this;

      this.ready = false;

      if (_typeof(graph) === 'object') {
        if (typeof graph.addNode === 'function') {
          // Existing Graph object
          this.createNetwork(graph, callback);
          return;
        } // JSON definition of a graph


        noflo.graph.loadJSON(graph, function (err, instance) {
          var inst = instance;

          if (err) {
            callback(err);
            return;
          }

          inst.baseDir = _this2.baseDir;

          _this2.createNetwork(inst, callback);
        });
        return;
      }

      var graphName = graph;

      if (graphName.substr(0, 1) !== '/' && graphName.substr(1, 1) !== ':' && process && process.cwd) {
        graphName = "".concat(process.cwd(), "/").concat(graphName);
      }

      noflo.graph.loadFile(graphName, function (err, instance) {
        var inst = instance;

        if (err) {
          callback(err);
          return;
        }

        inst.baseDir = _this2.baseDir;

        _this2.createNetwork(inst, callback);
      });
    }
  }, {
    key: "createNetwork",
    value: function createNetwork(graph, callback) {
      var _this3 = this;

      this.description = graph.properties.description || '';
      this.icon = graph.properties.icon || this.icon;
      var graphObj = graph;

      if (!graphObj.name) {
        graphObj.name = this.nodeId;
      }

      graphObj.componentLoader = this.loader;
      noflo.createNetwork(graphObj, {
        delay: true,
        subscribeGraph: false
      }, function (err, network) {
        _this3.network = network;

        if (err) {
          callback(err);
          return;
        }

        _this3.emit('network', _this3.network); // Subscribe to network lifecycle


        _this3.subscribeNetwork(_this3.network); // Wire the network up


        _this3.network.connect(function (err2) {
          if (err2) {
            callback(err2);
            return;
          }

          Object.keys(_this3.network.processes).forEach(function (name) {
            // Map exported ports to local component
            var node = _this3.network.processes[name];

            _this3.findEdgePorts(name, node);
          }); // Finally set ourselves as "ready"

          _this3.setToReady();

          callback();
        });
      });
    }
  }, {
    key: "subscribeNetwork",
    value: function subscribeNetwork() {
      var _this4 = this;

      var contexts = [];
      this.network.on('start', function () {
        var ctx = {};
        contexts.push(ctx);
        return _this4.activate(ctx);
      });
      return this.network.on('end', function () {
        var ctx = contexts.pop();

        if (!ctx) {
          return;
        }

        _this4.deactivate(ctx);
      });
    }
  }, {
    key: "isExportedInport",
    value: function isExportedInport(port, nodeName, portName) {
      // First we check disambiguated exported ports
      var keys = Object.keys(this.network.graph.inports);

      for (var i = 0; i < keys.length; i += 1) {
        var pub = keys[i];
        var priv = this.network.graph.inports[pub];

        if (priv.process === nodeName && priv.port === portName) {
          return pub;
        }
      } // Component has exported ports and this isn't one of them


      return false;
    }
  }, {
    key: "isExportedOutport",
    value: function isExportedOutport(port, nodeName, portName) {
      // First we check disambiguated exported ports
      var keys = Object.keys(this.network.graph.outports);

      for (var i = 0; i < keys.length; i += 1) {
        var pub = keys[i];
        var priv = this.network.graph.outports[pub];

        if (priv.process === nodeName && priv.port === portName) {
          return pub;
        }
      } // Component has exported ports and this isn't one of them


      return false;
    }
  }, {
    key: "setToReady",
    value: function setToReady() {
      var _this5 = this;

      if (typeof process !== 'undefined' && process.execPath && process.execPath.indexOf('node') !== -1) {
        process.nextTick(function () {
          _this5.ready = true;
          return _this5.emit('ready');
        });
      } else {
        setTimeout(function () {
          _this5.ready = true;
          return _this5.emit('ready');
        }, 0);
      }
    }
  }, {
    key: "findEdgePorts",
    value: function findEdgePorts(name, process) {
      var _this6 = this;

      var inPorts = process.component.inPorts.ports;
      var outPorts = process.component.outPorts.ports;
      Object.keys(inPorts).forEach(function (portName) {
        var port = inPorts[portName];

        var targetPortName = _this6.isExportedInport(port, name, portName);

        if (targetPortName === false) {
          return;
        }

        _this6.inPorts.add(targetPortName, port);

        _this6.inPorts[targetPortName].on('connect', function () {
          // Start the network implicitly if we're starting to get data
          if (_this6.starting) {
            return;
          }

          if (_this6.network.isStarted()) {
            return;
          }

          if (_this6.network.startupDate) {
            // Network was started, but did finish. Re-start simply
            _this6.network.setStarted(true);

            return;
          } // Network was never started, start properly


          _this6.setUp(function () {});
        });
      });
      Object.keys(outPorts).forEach(function (portName) {
        var port = outPorts[portName];

        var targetPortName = _this6.isExportedOutport(port, name, portName);

        if (targetPortName === false) {
          return;
        }

        _this6.outPorts.add(targetPortName, port);
      });
      return true;
    }
  }, {
    key: "isReady",
    value: function isReady() {
      return this.ready;
    }
  }, {
    key: "isSubgraph",
    value: function isSubgraph() {
      return true;
    }
  }, {
    key: "isLegacy",
    value: function isLegacy() {
      return false;
    }
  }, {
    key: "setUp",
    value: function setUp(callback) {
      var _this7 = this;

      this.starting = true;

      if (!this.isReady()) {
        this.once('ready', function () {
          _this7.setUp(callback);
        });
        return;
      }

      if (!this.network) {
        callback(null);
        return;
      }

      this.network.start(function (err) {
        if (err) {
          callback(err);
          return;
        }

        _this7.starting = false;
        callback();
      });
    }
  }, {
    key: "tearDown",
    value: function tearDown(callback) {
      this.starting = false;

      if (!this.network) {
        callback(null);
        return;
      }

      this.network.stop(function (err) {
        if (err) {
          callback(err);
          return;
        }

        callback();
      });
    }
  }]);

  return Graph;
}(noflo.Component);

exports.getComponent = function (metadata) {
  return new Graph(metadata);
};